module.exports = __webpack_public_path__ + "img/ic_equipment-active.a88b1a08.svg";